export interface CountryConfig {
    visaTypes: string[];
    offices: string[];
}

export const COUNTRIES = [
    { name: 'İNGİLTERE', code: 'UK', image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1000&auto=format&fit=crop', color: 'from-blue-500 to-blue-600' },
    { name: 'AMERİKA', code: 'US', image: 'https://images.unsplash.com/photo-1508433957232-3107f5fd5995?q=80&w=1000&auto=format&fit=crop', color: 'from-red-500 to-blue-800' },
    { name: 'YUNANİSTAN', code: 'GR', image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=1000&auto=format&fit=crop', color: 'from-blue-400 to-blue-300' },
    { name: 'İSPANYA', code: 'ES', image: 'https://images.unsplash.com/photo-1543783207-ec64e4d95325?q=80&w=1000&auto=format&fit=crop', color: 'from-yellow-500 to-red-600' },
    { name: 'HOLLANDA', code: 'NL', image: 'https://images.unsplash.com/photo-1468476396571-4d6f2a427ee7?q=80&w=1000&auto=format&fit=crop', color: 'from-orange-500 to-orange-600' },
    { name: 'FRANSA', code: 'FR', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=1000&auto=format&fit=crop', color: 'from-blue-600 to-red-600' },
    { name: 'ALMANYA', code: 'DE', image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&q=80&w=1000', color: 'from-yellow-400 to-red-500' },
    { name: 'İTALYA', code: 'IT', image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&q=80&w=1000', color: 'from-green-500 to-red-500' }
];

export const COUNTRY_CONFIG: Record<string, CountryConfig> = {
    'İTALYA': {
        visaTypes: ['Eğitim Vizesi (Lisans, Yüksek Lisans, Erasmus)', 'Turistik', 'Ticari'],
        offices: [
            'İstanbul - Gayrettepe', 'İstanbul - Altunizade', 'İstanbul - Bursa', 'İstanbul - Trabzon',
            'Ankara - Merkez', 'Ankara - Gaziantep',
            'İzmir - Merkez', 'İzmir - Adana', 'İzmir - Antalya'
        ]
    },
    'ALMANYA': {
        visaTypes: ['Eğitim Vizesi (Dil Okulu, Lisans, Yüksek Lisans, Erasmus)', 'Turistik', 'Ticari', 'Aile/Arkadaş Ziyareti'],
        offices: [
            'İstanbul - Gayrettepe', 'İstanbul - Altunizade', 'İstanbul - Bursa',
            'Ankara - Merkez', 'Ankara - Gaziantep', 'Ankara - Trabzon',
            'İzmir - Merkez', 'İzmir - Antalya'
        ]
    },
    'FRANSA': {
        visaTypes: ['Turistik', 'Aile Ziyareti', 'Ticari'],
        offices: ['İstanbul', 'Ankara', 'İzmir', 'Gaziantep']
    },
    'HOLLANDA': {
        visaTypes: ['Turistik', 'Ticari', 'Aile Ziyareti'],
        offices: ['İstanbul', 'Ankara', 'İzmir']
    },
    'İSPANYA': {
        visaTypes: ['Turistik', 'Ticari', 'Aile Ziyareti'],
        offices: ['İstanbul', 'Ankara', 'İzmir']
    },
    'YUNANİSTAN': {
        visaTypes: ['Turistik', 'Ticari', 'Aile Ziyareti'],
        offices: ['İstanbul', 'Ankara', 'İzmir']
    },
    'AMERİKA': {
        visaTypes: ['B1/B2 Vize Türü (Turistik/Ticari)'],
        offices: ['İstanbul Konsolosluk', 'Ankara Konsolosluk']
    },
    'İNGİLTERE': {
        visaTypes: ['Turistik'],
        offices: ['İstanbul', 'İzmir', 'Ankara']
    }
};
